import * as tmi from "tmi.js";
import emitter from "./emitter.js";
import { getRegistrationData, saveOrUpdateRegistrationData } from "@services/indexdb";
import { TWITCH_KEY, TWITCH_USER } from "@models/config.ts";
import { TwitchChannel } from "@interfaces/TwitchChannel";
import { obterDataAtual } from "@models/helpers";
import { addVideoToPlaylist } from "@models/playlist.js";


/**
 * Configura o canal da Twitch.
 * @returns O nome do canal configurado ou null se não estiver configurado.
 */
async function setupTwitchChannel(): Promise<string | null> {
  try {
    const { channelName }: TwitchChannel = await getRegistrationData(
      "twitch",
      "channel"
    );
    if (channelName) {
      console.info("Registro [channelName] recuperado:", channelName);
      return channelName;
    } else {
      console.info("Registro [channelName] não encontrado.");
      return null;
    }
  } catch (error) {
    console.error("Erro ao obter registro:", error);
    return null;
  }
}

/**
 * Inicializa e conecta o bot ao chat da Twitch.
 */
async function setupTwitch() {
  /**
   * O nome do canal da Twitch.
   * @type {string | null}
   */
  const TWITCH_CHANNEL = await setupTwitchChannel();

  /**
   * Cliente TMI para interagir com o chat da Twitch.
   * @type {tmi.Client}
   */
  const Client = new tmi.Client({
    options: { debug: false },
    connection: {
      secure: true,
      reconnect: true,
    },
    identity: {
      username: TWITCH_USER,
      password: TWITCH_KEY,
    },
    channels: [TWITCH_CHANNEL as string],
  });

  Client.on(`chat`, (channel, tags: tmi.ChatUserstate, message, self) => {
    if (!self) {
      console.log(`${tags["username"]}: ${message}`);
    }
    console.debug(channel, tags);
    console.log("----------- chat ------------\n");
  });

  Client.on("cheer", async (channel: string, userstate: tmi.ChatUserstate, message: string) => {
    console.info(userstate.bits);
    const id = userstate.username;
    let { bits } = await getRegistrationData<any>(`usersChat`, id);

    bits = Number(userstate.bits) + Number(bits | 0);
    await saveOrUpdateRegistrationData<any>(`usersChat`, { id, bits } as any);
    console.debug(channel, message);

    console.log("---------- - CHEER - ---------\n");
  });

  Client.on("mod", (channel: string, username: string): void => {
    console.info("mod", username);
    console.debug(channel);

    console.log("---------- - mod - ---------\n");
  });

  Client.on("mods", (channel: string, mods: string[]): void => {
    console.info("mods", mods);
    console.debug(channel);
    console.log("---------- - mods - ---------\n");
  });

  Client.on("message", async (channel, tags, message, self) => {
    if (self || !message.startsWith("!")) return;

    const args = message.slice(1).split(" ");
    const command = args.shift()?.toLowerCase();

    if (command === "saldo") {
      try {
        const id = tags.username;
        const user = (await getRegistrationData(`usersChat`, id)) as any;
        const msg = `Saldo: ${Number(user.bits|0)} Bits`;
        await Client.say(channel, `@${tags.username} - ${msg}`);

      } catch (error: any) {
        console.error("Erro ao consultar o saldo! ", error);
      }
    }

    if (command === "playlist") {
      const cost = Number(localStorage.getItem("musicCost"));
      console.log(cost);
      try {
        const id = tags.username;
        const user = (await getRegistrationData(`usersChat`, id)) as any;
        if (!user.bits || (user.bits < cost && cost > 0)) {
          const msg = `Bits insuficientes, necessário: ${cost} Bits. Saldo: ${Number(user.bits|0)} Bits`;
          await Client.say(channel, `@${tags.username} - ${msg}`);
          throw new Error(msg);
        }
        user.bits -= cost;
        await saveOrUpdateRegistrationData("usersChat", user);
        
        addVideoToPlaylist("playlist", {
          videoId: message.split(" ").slice(1).join(" "),
          username: tags.username,
        });
      } catch (error: any) {
        console.error("Erro ao operar os bits! ", error);
      }
    }
  });

  emitter.on("playlistUpdate", (callback) => {
    console.log("playlistUpdate", callback);
    if (!callback) return;
    const channel = String(localStorage.getItem("channel"));
    const { data, on } = callback;
    if (on == "addVideo")
      Client.say(
        channel,
        `@${data.username}, adicionou à playlist: "${data.title}"`
      );
  });

  Client.on("join", async (channel, id, self) => {
    console.debug(self);
    console.log("entrando:", id);
    try {
      let join = obterDataAtual("DD hh:mm:ss");
      let logged = true;
      await saveOrUpdateRegistrationData<any>(`usersChat`, {
        id,
        join,
        logged,
      } as any);
      await emitter.emit("chat", { channel, id, logged, action: { join } });
    } catch (error) {
      console.error("Erro ao entrar no canal:", error);
    }
  });

  Client.on("part", async (channel, id, self) => {
    console.debug(self);

    console.log("saindo:", id);

    try {
      let part = obterDataAtual("DD hh:mm:ss");
      let logged = false;
      await saveOrUpdateRegistrationData<any>(`usersChat`, {
        id,
        part,
        logged,
      } as any);
      await emitter.emit("chat", { channel, id, logged, action: { part } });
    } catch (error) {
      console.error("Erro ao sair no canal:", error);
    }
  });

  Client.on("connected", (addr: string, port: number) => {
    console.log(`* Connected to ${addr}:${port}`);
  });

  Client.connect();
}

setupTwitch();
